import { render, staticRenderFns } from "./DailyMayorBook.vue?vue&type=template&id=07346355&scoped=true"
import script from "./DailyMayorBook.vue?vue&type=script&lang=js"
export * from "./DailyMayorBook.vue?vue&type=script&lang=js"
import style0 from "./DailyMayorBook.vue?vue&type=style&index=0&id=07346355&prod&lang=css"
import style1 from "./DailyMayorBook.vue?vue&type=style&index=1&id=07346355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07346355",
  null
  
)

export default component.exports